import type { ClientMessage } from '@cube-rush/shared';

/**
 * Whether a message that may already have reached the server can be sent again. After a
 * connection breaks the client cannot tell whether its last messages arrived, and losing a
 * finished level would keep the player from ever finishing the race. So messages the server
 * ignores when repeated are sent again: a finished level (dropped once the server's
 * progress is past it) and giving up (dropped once quit). A death would be counted twice
 * and a boost shown twice, so those are dropped instead (the server misses a death at worst).
 */
export function canResend(message: ClientMessage): boolean {
  if (message.t === 'race.quit') return true;
  return message.t === 'race.event' && message.e.k === 'level';
}
